<template>
    <div :class="$style.root" :key="key" v-if="hackReset">
        <div class="header-center">
            <SideMenu />
            <!--  -->
            <div class="whitespace"></div>
            <!-- <keep-alive> -->
            <a-form class="g-form" v-if="userInfo.org_id" layout="inline">
                <a-form-item
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol">
                    <a-input v-model="keywords" @keyup.enter.native="handleSubmit" placeholder="请输入关键词" />
                </a-form-item>
                <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
                    <a-button @click="handleSubmit" style="background: rgb(53, 106, 238); border: none; color: #fff;">
                        搜索
                    </a-button>
                </a-form-item>
            </a-form>
            <!-- </keep-alive> -->

            <!--  -->
            <a-dropdown overlay-class-name="header-dropdown" v-if="hackReset">
                <div class="user-box">
                    <a-avatar icon="user" />
                    <dl>
                        <dt v-if="userInfo.user_name">{{ userInfo.user_qname }}</dt>
                        <dt class="nulogin" @click="Login" v-else>未登录</dt>
                    </dl>
                </div>
                <a-menu v-if="userInfo.user_name" slot="overlay" theme="dark">
                    <a-menu-item>
                        <a-button block type="link" icon="user" @click="onShowProfile">个人中心</a-button>
                    </a-menu-item>
                    <a-menu-item>
                        <a-button block type="link" icon="poweroff" @click="onExit">退出</a-button>
                    </a-menu-item>
                </a-menu>
            </a-dropdown>

            <loginView></loginView>
            <a-modal
                title="版本升级"
                :visible="visible"
                :confirm-loading="confirmLoading"
                @ok="handleOk"
                @cancel="handleCancel">
                <div>
                    <div class="clearfix">
                        <a-upload
                            list-type="picture"
                            action="//jsonplaceholder.typicode.com/posts/"
                            :preview-file="previewFile">
                            <a-button> <a-icon type="upload" /> Upload </a-button>
                        </a-upload>
                    </div>
                </div>
            </a-modal>
        </div>

    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import eventBus from '../utils/eventBus';
    import loginView from './components/loginView.vue';
    import auth from '../utils/auth';
    import SideMenu from './SideMenu.vue';


    export default {
        inject: ['bus', 'reload'],
        name: 'Header',
        components: { SideMenu, loginView },
        data() {
            return {
                userState: false,
                testStu: false,
                formLayout: 'horizontal',
                keywords: '',
                hackReset: true,
                key: 0,
                visible: false,
                confirmLoading: true,


            };
        },
        computed: {
            ...mapState(['userInfo']),
            formItemLayout() {
                const { formLayout } = this;
                return formLayout === 'horizontal'
                    ? {
                        wrapperCol: { span: 30 },
                    }
                    : {};
            },
            buttonItemLayout() {
                const { formLayout } = this;
                return formLayout === 'horizontal'
                    ? {
                        wrapperCol: { span: 30 },
                    }
                    : {};
            },
            loginStatu() {
                if (this.userInfo.user_name) {
                    return true;
                }
                return false;
            },
        },
        watch: {
        // loginStatu() {
        //     this.testStu = this.loginStatu;
        // },
        },
        mounted() {
            console.log(this.userInfo);
            if (!auth.checkToken()) {
                this.testStu = false;
            } else {
                this.testStu = true;
            }
        },
        methods: {
            ...mapActions(['loginOut']),
            onExit() {
                const self = this;
                self.$confirm({
                    title: '确定退出系统吗？',
                    onOk: () => {
                        auth.removeUserInfo();
                        auth.removeToken();

                        self.loginOut({});
                        self.$message.success('已退出');
                        // self.$forceUpdate();
                        // self.liginOut({});
                        // self.reload();
                        // self.reset();
                        self.$router.go(0);

                    // self.$router.push({ name: 'IndexVideo', params: { loginOut: 'loginOut' } });
                    // this.loginStatu=false;


                    // this.outLogin(); //增加退出登录
                    },
                });
                self.$forceUpdate();
            },
            Login() {
                eventBus.$emit('show-login-dialog', true);
            },
            handleFormLayoutChange(e) {
                this.formLayout = e.target.value;
            },
            handleSubmit() {
                const { keywords } = this;
                if (!keywords) {
                    this.$message.error('搜索内容不能为空');
                    return;
                }
                this.$router.push({ name: 'SearchView', params: { keywords } });
                this.handlePassVal();
            },
            onShowProfile() {
                this.$router.push({ name: 'PersonalCenterView' });
            },
            handlePassVal() {
                const { keywords } = this;
                this.bus.$emit('keywords', { keywords });
            },
            reset() {
                this.hackReset = false;
                this.$nextTick(() => {
                    this.hackReset = true;
                });
            },
            handleOk() {

            },
            handleCancel() {

            },
            previewFile(file) {
                console.log('Your upload file:', file);
                // Your process logic. Here we just mock to the same file
                return fetch('https://next.json-generator.com/api/json/get/4ytyBoLK8', {
                    method: 'POST',
                    body: file,
                })
                    .then(res => res.json())
                    .then(({ thumbnail }) => thumbnail);
            },

        },
    };
</script>

<style lang="less" module>
@import "../styles/variables";

.root {
    display: flex;
    align-items: center;
    height: 54px;
    background: #165abb;

    :global {
        @media screen and (max-width: 768px) {
            .g-form {
                display: none;
            }
        }

        .whitespace {
            flex: 1;
        }

        .g-form {
            margin-top: 8px;
        }

        .ant-badge {
            margin: 0 30px;
            cursor: pointer;
        }

        .header-center {
            width: 1180px;
            margin: auto;
            display: flex;
            height: 100%;
            justify-content: space-between;

            .user-box {
                display: flex;
                align-items: center;
                height: inherit;
                color: white;

                .ant-avatar {
                    background-color: white;
                    border: 1px solid white;

                    i {
                        color: @primary-color;
                    }
                }

                dl {
                    margin: 0 0 0 10px;

                    dt {
                        font-size: 14px;
                    }

                    dd {
                        margin: 0;
                        font-size: 12px;
                    }
                }

                .anticon {
                    font-size: 16px;
                }

                .nulogin {
                    cursor: pointer;
                }
            }
        }
    }
}

:global .header-dropdown {
    min-width: 160px !important;

    .ant-dropdown-menu-item {
        padding: 0;
    }

    .ant-btn {
        text-align: left;
        color: white;
        padding: 10px 15px;
        height: auto;
    }
}
</style>
